import {
  FETCH_NAVIGATION_PENDING,
  FETCH_NAVIGATION_REJECTED,
  FETCH_NAVIGATION_FULFILLED,
  SET_SELECTED_CATEGORY
} from "../constants/navigation";

const initialState = {
  pending: true,
  menuItems: [],
  selectedCategory:null
};

export const navigation = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NAVIGATION_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_NAVIGATION_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_NAVIGATION_FULFILLED:
      return {
        ...state,
        menuItems: action.response.menu,
        pending: false,
        error: []
      };
    case SET_SELECTED_CATEGORY:
      return{
        ...state,
        selectedCategory: action.data
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/navigation.js